/** ===========================================
 * FLYOUT MEGA MENU INTERACTIVITY
 * Handles hover states & active item highlights
 * =========================================== */

document.addEventListener('DOMContentLoaded', () => {
  const flyoutMenus = document.querySelectorAll('.mega-menu--flyout');

  if (!flyoutMenus.length) return;

  flyoutMenus.forEach(menu => {
    const items = menu.querySelectorAll('.flyout-menu__item');

    items.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        // Remove previous active states
        items.forEach(i => i.classList.remove('is-active'));
        // Add active state to current
        item.classList.add('is-active');
      });
    });

    // Clear active when leaving entire menu
    menu.addEventListener('mouseleave', () => {
      items.forEach(i => i.classList.remove('is-active'));
    });
  });
});
